import React from 'react';
import styled from 'styled-components';
import { Runtime } from '@hud/portal-dtos/webapp-common.dto';

import { runtimeToDisplay } from './common';
import { RuntimeIcon } from './RuntimeIcon';

export interface RuntimeLabelProps {
  runtime: Runtime;
}

const Icon = styled(RuntimeIcon)``;

const Container = styled.div`
  display: flex;
  gap: 8px;

  & ${Icon} {
    display: flex;
  }
`;

export const RuntimeLabel: React.FC<RuntimeLabelProps> = ({ runtime }) => {
  return (
    <Container>
      <Icon runtime={runtime} />
      <span>{runtimeToDisplay[runtime]}</span>
    </Container>
  );
};
